import { type FC, useCallback } from 'react';
import type { ICustomFilter } from '../../../../../../helpers/helpers';
import RangeSliderFilter from '../../RangeSliderFilter';

interface ICustomFilterWithProps extends ICustomFilter {
  filterName: string;
  minValue?: number;
  maxValue?: number;
}

const RangeDualSlider: FC<ICustomFilterWithProps> = ({
  onChange,
  isAdvancedFilter,
  onExpressionTypeChange,
  filterName,
  minValue,
  maxValue,
}) => {
  const resolvedFilterName = isAdvancedFilter ? `${filterName}_advanced` : filterName;

  const currentYear = new Date().getFullYear();
  const resolvedMin = minValue ?? 1900;
  const resolvedMax = maxValue ?? currentYear;

  const valueChangeCallback = useCallback(
    (value: string) => {
      if (onChange) {
        onChange(value);
      }
    },
    [onChange],
  );

  return (
    <RangeSliderFilter
      filterName={resolvedFilterName}
      minValue={resolvedMin}
      maxValue={resolvedMax}
      onChange={valueChangeCallback}
      onExpressionTypeChange={onExpressionTypeChange}
    />
  );
};

export default RangeDualSlider;
